import { AppTypes, EventProps, WebTrackingEvent } from '@griply/types';
import { useCallback, useEffect, useRef } from 'react';
import { version } from 'shared/constants';
import { MixpanelService } from 'shared/services/tracking';
import { ID } from 'shared/types/id';

import { useUser } from './use-user';

export const useTrackEvents = () => {
  const user = useUser();
  const mixpanelRef = useRef<MixpanelService>();
  const userIdRef = useRef<ID>();

  useEffect(() => {
    if (mixpanelRef.current && user?.uid && user?.uid !== userIdRef.current) {
      // only reset when there was already a user logged in. Otherwise, the previous pages are not linked to the user.
      if (userIdRef.current) {
        mixpanelRef.current.reset();
      }
      mixpanelRef.current.identifyUser(user.uid);
      userIdRef.current = user.uid;
    }
  }, [user?.uid]);

  return useCallback(
    <TrackEvent extends WebTrackingEvent>(
      event: TrackEvent,
      eventProps: EventProps<TrackEvent>,
    ) => {
      if (!mixpanelRef.current) {
        mixpanelRef.current = new MixpanelService({
          app_type: window.electron
            ? window.electron.isMac
              ? AppTypes.ElectronMacApp
              : AppTypes.ElectronWinApp
            : AppTypes.WebApp,
          app_version: version,
        });
      }

      mixpanelRef.current.track(event, eventProps);
    },
    [],
  );
};
